import logoUrl from '../assets/logo.svg';
import { cn } from '../lib/cn';

interface LogoProps {
  className?: string;
  alt?: string;
}

export function Logo({ className, alt = 'Adspert' }: LogoProps) {
  return <img src={logoUrl} alt={alt} className={cn('block', className)} />;
}

export { logoUrl };
